export const SHARE_IMAGE_DIMENSIONS = {
  WIDTH: 1200,
  HEIGHT: 630,
}
